function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { cx } from "../../helpers/utils/cx";
import { Typography } from "./Typography";
export function TypographyStack(props) {
  const {
    children,
    gap,
    primary,
    secondary,
    primaryTypographyProps,
    secondaryTypographyProps,
    isReverse,
    variant = "base"
  } = props;
  let primaryElement = primary ?? children;
  let secondaryElement = secondary;
  let gapValue = gap;
  const variantPrimaryProps = {};
  const variantSecondaryProps = {};
  switch (variant) {
    case "sm":
      {
        variantPrimaryProps.variant = "body-secondary";
        variantPrimaryProps.color = "primary";
        variantSecondaryProps.variant = "label-secondary";
        variantSecondaryProps.color = "secondary";
        break;
      }
    case "sm-expressive":
      {
        variantPrimaryProps.variant = "body-secondary";
        variantPrimaryProps.color = "primary";
        variantSecondaryProps.variant = "label-primary";
        variantSecondaryProps.color = "primary";
        gapValue = gapValue ?? 1;
        break;
      }
    case "base":
    default:
      {
        variantPrimaryProps.variant = "body-primary";
        variantPrimaryProps.color = "primary";
        variantSecondaryProps.variant = "label-primary";
        variantSecondaryProps.color = "secondary";
        break;
      }
  }
  if (primaryElement != null && !isTypographyComponent(primaryElement)) {
    primaryElement = /*#__PURE__*/React.createElement(Typography, _extends({}, variantPrimaryProps, primaryTypographyProps), primaryElement);
  }
  if (secondaryElement != null && !isTypographyComponent(secondaryElement)) {
    secondaryElement = /*#__PURE__*/React.createElement(Typography, _extends({}, variantSecondaryProps, secondaryTypographyProps), secondaryElement);
  }
  const inlineStyles = _objectSpread({}, gapValue && {
    gap: getRemFromSpacingSize(gapValue)
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cx("flex", isReverse ? "flex-col-reverse" : "flex-col"),
    style: inlineStyles
  }, primaryElement, secondaryElement);
}
function isTypographyComponent(element) {
  return element != null && element.type === Typography;
}
function getRemFromSpacingSize(spacingValue) {
  return `${spacingValue / 4}rem`;
}